module.exports = __webpack_public_path__ + "img/JLTP_capable.0168e231.svg";